<template>
  <div class="common-tabs">
    <div :class="[isFixed? 'shade-box': '']"></div>
    <van-tabs
      v-model="currentIndex"
      @change="changeTabs"
      @scroll="scrollTabs"
      swipeable
      :swipe-threshold="canSwipeNum"
      sticky
      :ellipsis="false"
      :animated="true"
      offset-top="11.733vw"
      line-width="20vw"
      line-height="1"
      color="#E50914"
      title-active-color="#E50914"
    >
      <van-tab
        v-for="(item, index) in list"
        :key="index"
        :title="item.dictLabel"
      >
        <div class="content">
          <slot />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'CommonTabs',
  props: {
    list: {
      type: Array
    },
    canSwipeNum: { // 出现左右滑动的最大的tab的个数
      type: Number,
      default: 5
    },
    tabNum: { // 出现左右滑动的最大的tab的个数
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      currentIndex: 0, // 当前列
      isFixed: false, // 是否吸顶
      srcImg: 'https://partydevcloud.oss-cn-hangzhou.aliyuncs.com/platform/common/richtext/image/202105185ab9051a068d4e8f8336a1a1f83b3c60.jpg'
    }
  },
  watch: {
    tabNum: {
      immediate: true, // 很重要！！！
      handler (val) {
        this.currentIndex = val
      }
    }
  },
  methods: {
    // 跳转到第几页
    handleToIndex (index) {
      this.currentIndex = index
    },
    changeTabs (currentIndex) {
      console.log(currentIndex)
      this.$emit('change-tab', currentIndex, this.list[currentIndex])
    },
    scrollTabs (e) {
      if (this.isFixed === e.isFixed) {
        return
      }
      this.isFixed = e.isFixed
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  }
}
</script>

<style lang="scss" scoped>
.common-tabs {
  width: 100%;
  box-sizing: border-box;
  .shade-box {
    z-index: 2;
    position: fixed;
    top: $header-height;
    left: 0;
    width: 100%;
    height: 44px;
    box-shadow: 0px 11px 10px 0px rgba(51, 51, 51, 0.1);
  }
  /deep/.van-tabs {
    .van-sticky {
      padding: 0 20px;
      border-bottom: 1px solid #CCCCCC;
      .van-tab {
        padding-left: 0;
        padding-right: 0;
        font-size: 15px;
        &:not(:first-child) {
          margin-left: 50px;
        }
      }
    }
    .van-sticky--fixed {
      padding: 0 20px;
      background-color: #fff;
      box-sizing: border-box;
      border-bottom: none;
      .van-tab:not(:first-child) {
        margin-left: 45px;
      }
    }
    .van-tabs__nav--complete {
      padding-left: 0;
      padding-right: 0;
    }
    .van-tabs__line {
      padding: 0;
    }
    .content {
      width: 100%;
      // padding: 0 20px;
      // box-sizing: border-box;
    }
  }
}
</style>
